import {
  MouseEffectConfig,
  MouseEffectParams,
  SchemaGroup,
  EffectFourDirections,
} from '../../types';
import {
  angle,
  perspective,
  transitionDuration,
  directionFourSides,
  inverted,
  mouseEasing,
} from '../baseParams';

export interface SwivelMouse extends MouseEffectParams {
  angle: number;
  perspective: number;
  pivotAxis: string | EffectFourDirections;
}

const name = 'SwivelMouse';
const groups: SchemaGroup[] = ['mouse', 'animation'];

const pivotAxis = directionFourSides.enum
  ? ['center-horizontal', 'center-vertical', ...directionFourSides.enum]
  : [];

export const config: MouseEffectConfig<SwivelMouse> = {
  name,
  groups,
  schema: {
    transitionDuration: { ...transitionDuration },
    inverted: { ...inverted },
    transitionEasing: { ...mouseEasing },
    angle: { ...angle, min: 5, max: 85, default: 50 },
    perspective: { ...perspective, default: 1000 },
    pivotAxis: {
      type: 'string',
      enum: pivotAxis,
      default: 'top',
    },
  },
} as const;

export const responsiveConfig: MouseEffectConfig<SwivelMouse> = {
  name,
  groups,
  schema: {
    transitionDuration: { ...transitionDuration },
    inverted: { ...inverted },
    transitionEasing: { ...mouseEasing },
    angle: { ...angle, min: 5, max: 85, default: 50 },
    perspective: { ...perspective, default: 1000 },
    pivotAxis: {
      type: 'string',
      enum: pivotAxis,
      default: 'top',
    },
  },
} as const;
